import { State } from 'model/State';
import hamsClient from 'modules/hams';
import { selectHamsClientConfig } from 'modules/auth/selectors';
import { getImpersonationHeader } from 'util/mac/helpers';
import { baseAccountPublicApiUrl } from '../../index';

enum HttpStatus {
  'SUCCESS' = 200,
}

export const polling = async (
  remainingPath: string,
  maxPollingDuration: number,
  pollingInterval: number,
  state: State,
) => {
  const endTime = Date.now() + maxPollingDuration;

  return new Promise((resolve, reject) => {
    const getFromHams = async () => {
      try {
        const config = selectHamsClientConfig(state);
        const impersonationHeader = getImpersonationHeader(state);
        const data = await hamsClient.get(`${baseAccountPublicApiUrl}${remainingPath}`, {
          ...config,
          headers: {
            ...config.headers,
            ...impersonationHeader,
          },
        });

        if (data.status === HttpStatus.SUCCESS && data?.data) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          clearInterval(intervalId);
          resolve(data.data);
        } else if (Date.now() > endTime) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          clearInterval(intervalId);
          reject(new Error('Polling timed out'));
        }
      } catch (_error) {
        if (Date.now() > endTime) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          clearInterval(intervalId);
          reject(new Error('Polling timed out'));
        }
      }
    };

    const intervalId = setInterval(getFromHams, pollingInterval);

    getFromHams();
  });
};
